var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "supporters columns is-multiline" }, [
    !_vm.user
      ? _c(
          "div",
          { staticClass: "column is-full mb-5" },
          [
            _c("cat-uxo-hero", {
              attrs: { heading: _vm.heroHeading, content: _vm.heroContent }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "column is-12-mobile is-12-tablet is-5-widescreen mb-3 mb-lg-0"
      },
      [
        _c("h3", { staticClass: "mb-12px" }, [_vm._v("Top Contributors")]),
        _vm._v(" "),
        _vm.fetchingContributors
          ? [
              _c(
                "div",
                { staticClass: "content-loader" },
                [
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 500,
                        width: 500,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "72",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "144",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "216",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ]
          : [
              _vm.topContributors
                ? _c(
                    "ul",
                    { staticClass: "contributors rows" },
                    [
                      _vm._l(_vm.topContributors, function(contributor, index) {
                        return [
                          index <= 4
                            ? _c(
                                "li",
                                {
                                  staticClass:
                                    "contributor row columns t-navy px-1 px-md-3 py-12px"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column p-0 contributor__name py-12px"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(index + 1) +
                                          ". " +
                                          _vm._s(contributor[0].name) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column p-0 contributor__total font-weight-light"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(contributor.length) +
                                          "\n                            Contributions\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column p-0 contributor__btn text-sm-right"
                                    },
                                    [
                                      _vm.user &&
                                      (_vm.user.eod_technician ||
                                        _vm.user.technical_interest)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-ghost bg-white",
                                              attrs: {
                                                href:
                                                  "/members/" +
                                                  contributor[0].contributor_id
                                              }
                                            },
                                            [_vm._v("View Profile")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.user && _vm.user.guest
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-ghost bg-white",
                                              attrs: { href: "/sign-up" }
                                            },
                                            [_vm._v("Sign Up")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.user
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-ghost bg-white",
                                              attrs: { href: "/login" }
                                            },
                                            [_vm._v("Login")]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-12-tablet is-7-widescreen" },
      [
        _c("h3", { staticClass: "mb-12px" }, [_vm._v("Contributors")]),
        _vm._v(" "),
        _vm.fetchingContributors
          ? [
              _c(
                "div",
                { staticClass: "content-loader" },
                [
                  _c(
                    "ContentLoader",
                    {
                      attrs: {
                        height: 500,
                        width: 500,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "0",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "72",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "144",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "0",
                          y: "216",
                          rx: "0",
                          ry: "0",
                          width: "500",
                          height: "56"
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ]
          : [
              _vm.contributors
                ? _c(
                    "ul",
                    { staticClass: "contributors rows" },
                    [
                      _vm._l(_vm.contributors, function(contributor) {
                        return [
                          _c(
                            "li",
                            {
                              staticClass:
                                "contributor row columns t-navy px-1 px-md-3 py-12px"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column p-0 contributor__name py-12px"
                                },
                                [_vm._v(_vm._s(contributor[0].name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column p-0 contributor__total font-weight-light"
                                },
                                [
                                  _vm._v(
                                    _vm._s(contributor.length) +
                                      "\n                            Contributions\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "column p-0 contributor__btn text-sm-right"
                                },
                                [
                                  _vm.user &&
                                  (_vm.user.eod_technician ||
                                    _vm.user.technical_interest)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-ghost bg-white",
                                          attrs: {
                                            href:
                                              "/members/" +
                                              contributor[0].contributor_id
                                          }
                                        },
                                        [_vm._v("View Profile")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user && _vm.user.guest
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-ghost bg-white",
                                          attrs: { href: "/sign-up" }
                                        },
                                        [_vm._v("Sign Up")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.user
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn btn-ghost bg-white",
                                          attrs: { href: "/login" }
                                        },
                                        [_vm._v("Login")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc11e866", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc11e866","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Supporters.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bc11e866","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Supporters.vue
// module chunks = 0 1